import React from "react";
import styled from "styled-components";
import {GrFormNext, GrFormPrevious} from "react-icons/gr";

const Pagination = ({
                        page = 1,
                        totalPages = 1,
                        onChange,
                        visibleCount = 5,
                        className,
                    }) => {
    if (totalPages <= 1) return null;

    const groupIndex = Math.floor((page - 1) / visibleCount);
    const startPage = groupIndex * visibleCount + 1;
    const endPage = Math.min(startPage + visibleCount - 1, totalPages);
    const length = endPage - startPage + 1;

    const go = (p) => {
        if (!onChange) return;
        if (p < 1 || p > totalPages) return;
        if (p === page) return;
        onChange(p);
    };

    return (
        <Wrap className={className}>
            <ArrowBtn
                onClick={() => go(page - 1)}
                className={`${page === 1 ? "disabled" : ""}`}
            >
                <GrFormPrevious size={16}/>
            </ArrowBtn>

            {Array.from({ length }, (item, idx) => {
                const paging = startPage + idx;
                return (
                    <PageBtn
                        key={paging}
                        onClick={() => go(paging)}
                        className={`${paging === page ? "active" : ""}`}
                    >
                        {paging}
                    </PageBtn>
                );
            })}

            <ArrowBtn
                onClick={() => go(page + 1)}
                className={`${page === totalPages ? "disabled" : ""}`}
            >
                <GrFormNext size={16}/>
            </ArrowBtn>
        </Wrap>
    );
};

const Wrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
const ArrowBtn = styled.div`

    padding: 10px;
    border-radius: 4px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #e5e7eb;
    line-height: 1;
    &.disabled{
        opacity: .6;
        pointer-events: none;
    }
    &:hover{
        background-color: #e5e7eb;
    }
`;

const PageBtn = styled.div`
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #e5e7eb;
    line-height: 1.4;
    &.active{
        color: #fff;
        background-color: #000;
    }
    &:hover{
        background-color: #e5e7eb;
        &.active{
            background-color: #000;
            color: #fff;
        }
    }
`;

export default Pagination;
